<template>
    <v-card class="pb-3 px-2 pt-1" style="background-color:#f1ffdc">
        <v-progress-linear
            v-if="loading"
            :indeterminate="true"
            color="success"
        ></v-progress-linear>
        <div v-if="!loading">
            <v-layout
                v-if="!getVisits().length"
                justify-center
                align-center
                class="my-3 headline"
            >
                No Site Visits
            </v-layout>
            <div v-if="getVisits().length">
                <v-card
                    class="pb-4 pt-2 px-3 my-3"
                    v-for="(visit, index) in getVisits()"
                >
                    <v-layout row class="px-3 pb-1 pt-3">
                        <div class="font-weight-medium mr-2 width-200">
                            Date:
                        </div>
                        <div>
                            {{ visit.timestamp | time }}
                        </div>
                    </v-layout>
                    <v-layout row class="px-3 py-1" v-if="visit.clientIP">
                        <div class="font-weight-medium mr-2 width-200">
                            Client IP:
                        </div>
                        <div>
                            {{ visit.clientIP }}
                        </div>
                    </v-layout>
                    <v-layout row class="px-3 py-1" v-if="visit.source">
                        <div class="font-weight-medium mr-2 width-200">
                            Source:
                        </div>
                        <div>
                            {{ visit.source }}
                        </div>
                    </v-layout>
                </v-card>
                <v-layout justify-center>
                    <v-pagination
                        v-model="pagination.page"
                        :length="pages"
                        :total-visible="7"
                        v-on:input="setPagianation"
                    ></v-pagination>
                </v-layout>
            </div>
        </div>
    </v-card>
</template>
<script>
import { formatPhoneNumber } from "../../utils/helpers.js";
export default {
    props: {},
    data() {
        return {
            loading: false,
            siteVisits: [],
            visits: [],
            pagination: {
                totalCount: 0,
                rowsPerPage: 5,
                page: 1,
            },
        };
    },
    watch: {},
    async created() {
        await this.loadSiteVisits();
    },
    mounted() {},
    beforeDestroy() {},
    computed: {
        pages() {
            return this.pagination.rowsPerPage
                ? Math.ceil(
                      this.siteVisits.length / this.pagination.rowsPerPage
                  )
                : 0;
        },
    },
    methods: {
        async loadSiteVisits() {
            const siteVisits = await this.$http.get(
                "api/site/getForAccount?accountID=" + this.$route.params.id
            );
            this.siteVisits = siteVisits;
            this.visits = siteVisits.slice(0, 5);
            this.pagination.totalCount = siteVisits.length;
        },
        setPagianation() {
            if (this.getSkip() >= this.pagination.totalCount) return;

            const number =
                (this.pagination.page - 1) * this.pagination.rowsPerPage;

            this.visits = this.siteVisits.slice(
                number,
                number + this.pagination.rowsPerPage
            );
        },
        getSkip() {
            const page = this.pagination.page - 1;

            let skip = page * this.pagination.rowsPerPage;

            if (skip >= this.pagination.totalCount) {
                skip = this.pagination.totalCount - this.pagination.rowsPerPage;
            }

            return skip;
        },
        getVisits() {
            return this.visits;
        },
    },
};
</script>
<style></style>
